/* app/js/src/components/alerts/alerts.component.scss */
.alerts-component {
  min-height: 100px;
  width: 370px;
  padding: 10px;
}
.alerts-component > .header > .title {
  color: #ffffff;
  font-weight: bold;
  font-size: 12px;
}
.alerts-component > .header > .settings-button {
  float: right;
}
.alerts-component > .content {
  margin-top: 10px;
}
/*# sourceMappingURL=alerts.component.css.map */
